import { RxJsonSchema, RxDocument } from 'rxdb';

export class Lookup {
    _id: string
    values: any[]
}

export const lookupMethods = {
}

export type LookupDoc = RxDocument<Lookup,typeof lookupMethods>

export const lookupSchema: RxJsonSchema<Lookup> = {
    title: 'lookup schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        _id: {
            type: 'string',
            primary: true
        },
        values: { 
            type: 'array'
        }
    },
    indexes: [ '_id' ]
};
